import Badge from './Badge';

export { BadgeVariant, BadgeSize } from './constants';
export default Badge;
